export function isChar(e: KeyboardEvent) {
  return e && e.key.length === 1;
}
